<template>
      <main class="production" v-if="!Object.keys(artists).length !== 0">
        <div class="roller"></div>
        <section class="represent sticky">
            <div v-if="artists.text" class="title wrap" v-html="artists.text"></div>
            <div v-else class="title">
                  <span>Production</span>
            </div>
          <div class="spacer"></div>
        </section>
        <section class="production-wrapper" ref="production">
            <div v-for="(item, index) in artists.items" :key="item.uid + index" class="production-item">
                <div class="production-item-inner">
                    <div class="production-item-media">
                        <template v-if="item.type == 'image'">
                            <router-link
                                :to="{
                                    name: 'project',
                                    params: { uid: item.artistuid, project: item.uid, num: 0 }
                                }"
                                :aria-label="item.title"
                            >
                                    <transition name="fade">
                                          <img :src="item.images[0].thumb" v-lazy="item.images[0].url" :alt="item.name" />
                                    </transition>
                                    <transition name="fade" slot="placeholder">
                                          <div class="preloader" slot="placeholder"></div>
                                    </transition>
                                <div class="production-item-credit">{{ item.artist }}<br>for <span class="italic">{{ item.title }}</span></div>
                            </router-link>
                        </template>
                        <template v-if="item.type == 'video'">
                            <router-link
                                :to="{
                                    name: 'project',
                                    params: { uid: item.artistuid, project: item.uid, num: 0 }
                                }"
                                :aria-label="item.title"
                                >
                                <video
                                    :src="item.videos[0].url"
                                    autoplay
                                    loop
                                    muted
                                    playsinline
                                ></video>
                                <div class="production-item-credit">{{ item.artist }}<br>for <span class="italic">{{ item.title }}</span></div>
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>
        </section>
      </main>
      <main v-else>
        <section>
          <div class="roller"></div>
          <div class="title loading">
            Loading
          </div>
        </section>
      </main>
    </template>
    
    <script>
    export default {
      metaInfo() {
        return {
          title: "SO Represent",
          titleTemplate: null
        };
      },
      created() {
        document.body.classList.add("home");
      },
      destroyed() {
        document.body.classList.remove("home");
      },
      computed: {
        artists() {
          return this.$store.state.production;
        }
      },
    };
    </script>
    
    <style lang="scss">
    .title.wrap {
      white-space: inherit !important;
    }
    .sticky {
      position: sticky !important;
      top:0 !important;
    }
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 1s;
    }
    .fade-enter,
    .fade-leave-to {
      opacity: 0 !important;
    }
    main {
      margin-top: 0;
      min-height: calc(100vh - (3.5 * var(--lh))) !important;
      .production-wrapper {
          max-width:1200px;
          margin:0 auto;
          margin-top:2rem;
      //     margin-top:30rem;
          @media only screen and (max-width:1440px) {
            // margin-top:35rem;
          }
          @media only screen and (max-width:1024px) {
            // margin-top:32rem;
          }
          display:flex;
          flex-wrap:wrap;
      //     position: relative;
      //     z-index: 90;
        .production-item:nth-child(odd) { 
            margin-top: 7rem;
      }
        .production-item {
            width:33%;
            max-height:60vmin;
            padding: 0 2rem;
            margin-bottom: 5rem;
            break-inside: avoid;
            @media only screen and (max-width:768px) {
              padding: 0 1rem;
              width:50%;
            }
        }
        .production-item-inner {
            height:100%;
            display:flex;
            flex-direction:column;
        }
        .production-item-media {
            flex: 1 1 0%;
        }
        .production-item-media img, .production-item-media video {
            max-height:60vmin;
            max-width:100%;
            display:block;
            width:auto;
        }
        .production-item:nth-child(odd) .production-item-inner {
            align-items: end;
        }
        .production-item-credit {
            flex: 0 0 0;
            margin-top: 0.5rem;
            @media only screen and (max-width:768px) {
              font-size:0.8rem;
              line-height:1.2;
            }
        }
      }
    }
    </style>
    